/**
 * Admin → Bookings (pages/reservations-review): which rows make the "Approve?" bucket and
 * who sees them where. Pure rules, so the page stays a thin caller and the rules are tested.
 *
 * "Approve?" (lib/inquiryStatus APPROVE) is a group/private dining inquiry the member
 * reported as booked, waiting for RM's approval. It is RM's work to do, so it sits under
 * In Progress (Kapil, 10/22). A restaurant's team never sees the word: to them the inquiry
 * reads Submitted (the API masks it too), so their Completed → Submitted list keeps the row.
 */
export const APPROVE_STATUS = 'Approve?'

/** A member-reported booking waiting for RM's approval. */
export const isApproveRow = r => !!r && r.reservationType === 'private' && r.status === APPROVE_STATUS

const bySortDateTime = (a, b) => (a.sortDateTime < b.sortDateTime ? -1 : a.sortDateTime > b.sortDateTime ? 1 : 0)

/** The Approve? bucket out of the in-progress data, soonest first (the In Progress order). */
export const approveRows = list => (Array.isArray(list) ? list.filter(isApproveRow).sort(bySortDateTime) : [])

/**
 * Whether Completed → Submitted keeps Approve? rows (as the masked Submitted entries).
 * A platform admin with no restaurant filter already has them under In Progress → Approve?,
 * so they are not listed twice; a restaurant viewer, or RM looking at one restaurant's view,
 * sees what the restaurant sees.
 */
export const incomingKeepsApprove = ({ isPlatformAdmin, restaurantFilter }) => !isPlatformAdmin || !!restaurantFilter
